/**
 * Tabs Render
 *
 * Rendering helpers for dataset-driven tab and panel state updates.
 */

type TabElementCollection = NodeListOf<HTMLElement> | HTMLElement[];

export function renderTabsByDataset(
    tabs: TabElementCollection,
    panels: TabElementCollection,
    datasetKey: string,
    activeValue: string,
): void {
    tabs.forEach((tab) => {
        const current = tab.dataset[datasetKey];
        const isActive = current === activeValue;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach((panel) => {
        const current = panel.dataset[datasetKey];
        panel.hidden = current !== activeValue;
    });
}
